import React, { Component } from 'react';

interface IProps {
    onClick?(v: any): void;
    customLabel?: string;
    customClass?: string;
    url?: string;
    type?:'primary'|'secondary'|'tertiary'|'transparent'
}

export class NextButton extends Component<IProps, any> {
    type() {
        return this.props.type ?? 'primary';
    }
    nextType() {
        return this.type() === 'primary' ? 'next' : 'next-secondary';
    }
    render() {
        return (
            <>
            {
            this.props.url ?
                <a className={`${this.props.customClass ?? ''} btn-${this.type()} ${this.nextType()} nohover`} href={this.props.url}>{this.props.customLabel ?? 'Next'}</a>
                :
                <div className={`${this.props.customClass ?? ''} btn-${this.type()} ${this.nextType()}`} onClick={this.props.onClick}>{this.props.customLabel ?? 'Next'}</div>
            }
            </>
            );
    }
}
